import { useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import userApi from "../../api/user/user.api";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import ProcessingBar from "utils/Processingbar";
import { setUser } from "../../redux/authSlice";
import { hashPassword } from "utils/hashPassword";

const SigninForm = ({ switchAuthState, actionState }) => {
  const dispatch = useDispatch();
  const [isLoginRequest, setIsLoginRequest] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const signinForm = useFormik({
    initialValues: {
      password: "",
      username: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .min(3, "Email must be at least 3 characters")
        .required("Email is required"),
      password: Yup.string()
        .min(3, "Password must be at least 3 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      setErrorMessage("");
      setIsLoginRequest(true);

      const hashedPassword = await hashPassword(values.password);

      // const { response, err } = await userApi.signin(values);

      const payload = {
        username: values.username,
        password: hashedPassword, // Send the hashed password instead of raw password
      };

      const { response, err } = await userApi.signin(payload);

      console.log({ response });

      if (response) {
        signinForm.resetForm();
        setIsLoginRequest(false);
        dispatch(setUser(response.data));
        dispatch(setAuthModalOpen(false));
        toast.success("Sign in successful");
      }

      if (err) {
        const errorMsg = err?.response?.data?.message || "Something went wrong";
        setErrorMessage(errorMsg);
        toast.error(errorMsg); // Show the error in a Toast
        setIsLoginRequest(false);
      }
    },
  });

  return (
    <form onSubmit={signinForm.handleSubmit} className="space-y-4 ">
      {/* Username Input */}
      <input
        type="text"
        name="username"
        placeholder="Email"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-textGray placeholder:text-textGray"
        value={signinForm.values.username}
        onChange={signinForm.handleChange}
      />
      {signinForm.touched.username && signinForm.errors.username && (
        <p className="text-red-500 text-sm">{signinForm.errors.username}</p>
      )}

      {/* Password Input */}
      <input
        type="password"
        name="password"
        placeholder="Password"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-textGray placeholder:text-textGray"
        value={signinForm.values.password}
        onChange={signinForm.handleChange}
      />
      {signinForm.touched.password && signinForm.errors.password && (
        <p className="text-red-500 text-sm">{signinForm.errors.password}</p>
      )}

      {/* Sign In Button */}
      <button
        type="submit"
        className="w-full bg-redlight hover:bg-reddark hover:text-white text-black py-2 rounded-md transition duration-300"
        style={{ background: "linear-gradient(-45deg, #f87171, #991b1b)" }}
        disabled={isLoginRequest}
      >
        {isLoginRequest ? <ProcessingBar /> : "Sign In"}
      </button>

      <button
        type="button"
        onClick={() => switchAuthState(actionState.forgot)}
        className="text-redlight text-sm hover:underline block text-center"
      >
        Forgot your password?
      </button>

      {/* Divider */}
      <div className="flex items-center my-8">
        <div className="flex-grow h-px bg-gray-500"></div>
        <span className="px-4 text-sm text-neutral-300">OR</span>
        <div className="flex-grow h-px bg-gray-500"></div>
      </div>

      {/* Social Login Buttons */}
      {/* <div className="flex justify-center space-x-4">
        <button onClick={google} className="p-2 rounded-full border">
          <img src={Google} alt="Google Login" className="w-8 h-8" />
        </button>
        <button onClick={facebook} className="p-2 rounded-full border">
          <img src={Facebook} alt="Facebook Login" className="w-8 h-8" />
        </button>
        <button onClick={github} className="p-2 rounded-full border">
          <img src={insta} alt="GitHub Login" className="w-8 h-8" />
        </button>
      </div> */}

      {/* Sign Up Link */}
      <button
        type="button"
        onClick={() => switchAuthState(actionState.signup)}
        className="w-full text-center text-textGray hover:text-white mt-4 border border-reddark py-2 rounded-md "
      >
        Sign Up
      </button>

      {/* Error Message */}
      {errorMessage && (
        <p className="text-red-500 text-sm text-center">{errorMessage}</p>
      )}
    </form>
  );
};

export default SigninForm;
